import React, { useState } from "react";
import { Button } from "primereact/button";
import { Password } from "primereact/password";
import { InputText } from "primereact/inputtext";
import { classNames } from "primereact/utils";
import { Link, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { useToast } from "../../utils/toast";
import { t } from "i18next";
import FormikValueIsValid from "../../utils/FormikValueIsValid";
import { CreateUserDto } from "../../services/account/account.dto";
import accountService from "../../services/account/account.service";
import { InputMask } from "primereact/inputmask";
import DropdownDatas from "../../utils/DropdownValues";
import { useAuth } from "../../utils/auth";
import { AutoComplete, AutoCompleteChangeEvent } from "primereact/autocomplete";
import { InputSwitch, InputSwitchChangeEvent } from "primereact/inputswitch";
import { ConfirmPopup, confirmPopup } from "primereact/confirmpopup";

const RegisterSebis = () => {
  const auth = useAuth();
  const toast = useToast();
  const navigate = useNavigate();

  const [filteredCountries, setFilteredCountries] = useState<any[]>([]);
  const allCountries = DropdownDatas.getOSBList();
  const [checked, setChecked] = useState<boolean>(false);

  const registerFormik = useFormik<CreateUserDto>({
    initialValues: {
      user_name: "",
      email: "",
      password: "",
      re_password: "",
      first_name: "",
      last_name: "",
      phone_number: "",
      osb: "",
      osb_gorevi: "",
      request_osbuk_user: false
    },
    enableReinitialize: true,
    validate: (data) => {
      const errors: any = {};

      //   if (!data.user_name || data.user_name === "") {
      //     errors.user_name = "Kullanıcı adı gereklidir.";
      //   }

      if (!data.email || data.email === "") {
        errors.email = "E-posta adresi gereklidir.";
      }

      if (!data.password || data.password === "") {
        errors.password = "Şifre gereklidir.";
      }

      if (!data.first_name || data.first_name === "") {
        errors.first_name = "Ad gereklidir.";
      }

      if (!data.last_name || data.last_name === "") {
        errors.last_name = "Soyad gereklidir.";
      }

      if (!data.osb || data.osb === "") {
        errors.osb = "OSB gereklidir.";
      }

      if (!data.osb_gorevi || data.osb_gorevi === "") {
        errors.osb_gorevi = "OSB Görevi gereklidir.";
      }

      if (!data.phone_number || data.phone_number === "") {
        errors.phone_number = "Telefon numarası gereklidir.";
      }

      if (!data.re_password || data.re_password === "") {
        errors.re_password = "Şifre tekrarı gereklidir.";
      }

      if (data.password !== data.re_password) {
        errors.password = "Şifreler eşleşmiyor.";
        errors.re_password = "Şifreler eşleşmiyor.";
      }

      return errors;
    },
    onSubmit: async (values) => {
      values.request_osbuk_user = checked;
      values.phone_number = values.phone_number
        .replace(/_/g, "")
        .replace(/ /g, "")
        .replace(/\(/g, "")
        .replace(/\)/g, "")
        .replace(/-/g, "");

      const res = await accountService.Register(values);
      if (!res?.result?.error && res?.result?.data) {
        auth.removeUserFromStorage();
        auth.setToken(res.result.data, true);
        toast.show("Kayıt işlemi başarılı.", "success");
        navigate("/app/homepage", { replace: true });
      } else {
        toast.show(res?.result?.error || "Kayıt işlemi sırasında bir hata oluştu.", "error");
      }
    }
  });

  const search = (event: { query: string }) => {
    const query = event.query.toLowerCase();
    const filtered = allCountries.filter((item) => item.label.toLowerCase().includes(query));
    setFilteredCountries(filtered);
  };

  const confirmRequestOsbukUser = async (check: InputSwitchChangeEvent) => {
    if (check.value) {
      if (check.originalEvent) {
        confirmPopup({
          target: check.originalEvent.target as HTMLElement,
          message:
            "Tam yetki talebinde bulunuyorsunuz. Kaydınız yönetici tarafından onaylandığında tam yetkili kullanıcı olacaksınız.",
          icon: "pi pi-info-circle",
          defaultFocus: "accept",
          acceptClassName: "p-button-success",
          acceptLabel: "Onayla",
          rejectLabel: "İptal",
          accept: async () => {
            setChecked(true);
          },
          reject: () => {
            setChecked(false);
          }
        });
      }
    } else {
      setChecked(false);
    }
  };

  return (
    <div className="surface-ground min-h-screen py-4 sm:py-6 px-3 sm:px-4 flex justify-content-center align-items-center">
      <form
        className="w-full"
        style={{ maxWidth: "860px" }}
        onSubmit={registerFormik.handleSubmit}
      >
        <div className="surface-card border-1 surface-border border-round-2xl shadow-3 p-4 sm:p-5 md:p-6">
          <div className="text-center mb-4 sm:mb-5">
            <Link to="/">
              <img src="/images/logoosbuk.png" alt="OSBÜK Logo" height="48" className="mb-2" />
            </Link>
            <div className="text-900 text-2xl sm:text-3xl font-bold mb-2">{t("SEBİS Kayıt Formu")}</div>
            <span className="text-600 text-sm sm:text-base">{t("Hesabınızı oluşturun ve SEBİS'e hemen giriş yapın.")}</span>
          </div>

          <div className="grid">
            <div className="col-12 md:col-6">
              <label htmlFor="first_name" className="text-900 font-medium block mb-1">
                {t("İsim")}
              </label>
              <InputText
                id="first_name"
                maxLength={100}
                type="text"
                placeholder={t("İsim")}
                className={classNames("w-full p-3", {
                  "p-invalid": FormikValueIsValid(registerFormik, "first_name")
                })}
                value={registerFormik.values.first_name}
                onChange={(e) => registerFormik.setFieldValue("first_name", e.target.value)}
              />
              {FormikValueIsValid(registerFormik, "first_name") && (
                <div className="p-error mt-2 text-sm">{registerFormik.errors.first_name}</div>
              )}
            </div>

            <div className="col-12 md:col-6">
              <label htmlFor="last_name" className="text-900 font-medium block mb-1">
                Soyisim
              </label>
              <InputText
                id="last_name"
                maxLength={100}
                type="text"
                placeholder="Soyisim"
                className={classNames("w-full p-3", {
                  "p-invalid": FormikValueIsValid(registerFormik, "last_name")
                })}
                value={registerFormik.values.last_name}
                onChange={(e) => registerFormik.setFieldValue("last_name", e.target.value.toLocaleUpperCase("tr"))}
              />
              {FormikValueIsValid(registerFormik, "last_name") && (
                <div className="p-error mt-2 text-sm">{registerFormik.errors.last_name}</div>
              )}
            </div>

            <div className="col-12 md:col-6">
              <label htmlFor="email" className="text-900 font-medium block mb-1">
                {t("E-posta")}
              </label>
              <InputText
                id="email"
                maxLength={50}
                type="email"
                placeholder={t("E-posta Adresi")}
                className={classNames("w-full p-3", {
                  "p-invalid": FormikValueIsValid(registerFormik, "email")
                })}
                value={registerFormik.values.email}
                onChange={(e) => registerFormik.setFieldValue("email", e.target.value)}
                autoComplete="email"
              />
              {FormikValueIsValid(registerFormik, "email") && (
                <div className="p-error mt-2 text-sm">{registerFormik.errors.email}</div>
              )}
            </div>

            <div className="col-12 md:col-6">
              <label htmlFor="phone_number" className="text-900 font-medium block mb-1">
                {t("Telefon Numarası")}
              </label>
              <InputMask
                id="phone_number"
                maxLength={50}
                keyfilter="int"
                mask="(0999) 999-99-99"
                placeholder={t("Telefon Numarası")}
                className={classNames("w-full p-3", {
                  "p-invalid": FormikValueIsValid(registerFormik, "phone_number")
                })}
                value={registerFormik.values.phone_number}
                onChange={(e) => registerFormik.setFieldValue("phone_number", e.target.value)}
              />
              {FormikValueIsValid(registerFormik, "phone_number") && (
                <div className="p-error mt-2 text-sm">{registerFormik.errors.phone_number}</div>
              )}
            </div>

            <div className="col-12 md:col-6">
              <label htmlFor="password" className="text-900 font-medium block mb-1">
                {t("Parola")}
              </label>
              <Password
                inputId="password"
                maxLength={128}
                value={registerFormik.values.password}
                onChange={(e) => registerFormik.setFieldValue("password", e.target.value)}
                placeholder={t("Parolanızı girin")}
                toggleMask
                className={classNames("w-full login-password", {
                  "p-invalid": FormikValueIsValid(registerFormik, "password")
                })}
                style={{ width: "100%", display: "flex" }}
                inputStyle={{ width: "100%" }}
                autoComplete="new-password"
                inputClassName="w-full p-3"
              />
              {FormikValueIsValid(registerFormik, "password") && (
                <div className="p-error mt-2 text-sm">{registerFormik.errors.password}</div>
              )}
            </div>

            <div className="col-12 md:col-6">
              <label htmlFor="re_password" className="text-900 font-medium block mb-1">
                Parola Tekrar
              </label>
              <Password
                inputId="re_password"
                maxLength={128}
                value={registerFormik.values.re_password}
                onChange={(e) => registerFormik.setFieldValue("re_password", e.target.value)}
                placeholder="Parolanızı tekrar girin"
                toggleMask
                className={classNames("w-full login-password", {
                  "p-invalid": FormikValueIsValid(registerFormik, "re_password")
                })}
                style={{ width: "100%", display: "flex" }}
                inputStyle={{ width: "100%" }}
                autoComplete="new-password"
                inputClassName="w-full p-3"
              />
              {FormikValueIsValid(registerFormik, "re_password") && (
                <div className="p-error mt-2 text-sm">{registerFormik.errors.re_password}</div>
              )}
            </div>

            <div className="col-12 md:col-6">
              <label className="text-900 font-medium block mb-1" htmlFor="osb">
                Bağlı Olduğunuz OSB / Kurum
              </label>
              <AutoComplete
                id="osb"
                maxLength={100}
                name="osb"
                inputId="osb"
                value={registerFormik.values.osb}
                suggestions={filteredCountries}
                field="label"
                completeMethod={search}
                onChange={(e: AutoCompleteChangeEvent) => {
                  registerFormik.setFieldValue("osb", e.value.value ? e.value.value : e.value);
                }}
                placeholder="Bağlı Olduğunuz OSB veya Kurum"
                className={classNames("w-full", {
                  "p-invalid": FormikValueIsValid(registerFormik, "osb")
                })}
                dropdown
              />
              {FormikValueIsValid(registerFormik, "osb") && (
                <div className="p-error mt-2 text-sm">{registerFormik.errors.osb}</div>
              )}
            </div>

            <div className="col-12 md:col-6">
              <label htmlFor="osb_gorevi" className="text-900 font-medium block mb-1">
                Çalıştığınız Kurumdaki Göreviniz
              </label>
              <InputText
                id="osb_gorevi"
                maxLength={100}
                type="string"
                placeholder="Çalıştığınız Kurumdaki Göreviniz"
                className={classNames("w-full p-3", {
                  "p-invalid": FormikValueIsValid(registerFormik, "osb_gorevi")
                })}
                value={registerFormik.values.osb_gorevi}
                onChange={(e) => registerFormik.setFieldValue("osb_gorevi", e.target.value)}
              />
              {FormikValueIsValid(registerFormik, "osb_gorevi") && (
                <div className="p-error mt-2 text-sm">{registerFormik.errors.osb_gorevi}</div>
              )}
            </div>

            <div className="col-12 flex align-items-center justify-content-center w-full my-3 gap-2">
              <InputSwitch
                id="roleRequestSwitch"
                checked={checked}
                onChange={async (e: InputSwitchChangeEvent) => await confirmRequestOsbukUser(e)}
              />
              <label htmlFor="roleRequestSwitch" className="text-sm text-700 cursor-pointer user-select-none">
                Sebis.tr sitemizde tam yetki talebinde bulunabilirsiniz.
              </label>
            </div>
            <ConfirmPopup />

            <div className="col-12 w-full mt-2">
              <Button label={t("Kayıt Ol")} className="w-full p-3 text-lg font-semibold" type="submit" />
            </div>

            <div className="col-12 text-center mt-3">
              <span className="text-600 text-sm">Zaten hesabınız var mı? </span>
              <Link
                to="/loginsebis"
                className="font-semibold text-sm text-primary cursor-pointer hover:underline ml-1"
              >
                Giriş Yapın
              </Link>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default RegisterSebis;
